import { pathFor } from "../../http";

export const basemapRoutes = {
  room: "/asset-editor/v1alpha1/basemaps/{id}",
  connect: "/asset-editor/v1alpha1/basemaps/{id}/connect",
  socket: "/asset-editor/v1alpha1/basemaps/{id}/socket",
  snapshot: "/asset-editor/v1alpha1/basemaps/{id}/snapshot",
  freeze: "/asset-editor/v1alpha1/basemaps/{id}/freeze",
  thaw: "/asset-editor/v1alpha1/basemaps/{id}/thaw",
} as const;

export const basemapPaths = {
  room: (versionId: string) => pathFor(basemapRoutes.room, { id: versionId }),
  connect: (versionId: string) => pathFor(basemapRoutes.connect, { id: versionId }),
  socket: (versionId: string) => pathFor(basemapRoutes.socket, { id: versionId }),
  snapshot: (versionId: string) => pathFor(basemapRoutes.snapshot, { id: versionId }),
  freeze: (versionId: string) => pathFor(basemapRoutes.freeze, { id: versionId }),
  thaw: (versionId: string) => pathFor(basemapRoutes.thaw, { id: versionId }),
} as const;
